export const defaultTableColumns = [
  {
    field: 'contractNo',
    title: '合同编号',
    width: '140',
  },
  {
    field: 'contractStatus',
    title: '合同状态', //
    width: '140',
  },
  {
    field: 'customerNameOne',
    title: '客户名称',
    width: '140',
  },
  {
    field: 'customerCodeOne',
    title: '客户编码',
    width: '140',
  },
  {
    field: 'dateStart',
    title: '开始日期',
    width: '140',
  },
  {
    field: 'dateEnd',
    title: '结束日期',
    width: '140',
  },
  {
    field: 'signatoryName', //
    title: '签约人',
    width: '140',
  },
  {
    field: 'signingDate',
    title: '签约日期',
    width: '140',
  },
  {
    field: 'contractPlace',
    title: '签约地点',
    width: '140',
  },
  {
    field: 'warehouseName', //
    title: '仓库名称',
    width: '140',
  },
  {
    field: 'goodsTypeName',
    title: '商品类型',
    width: '140',
  },
  {
    field: 'paymentMethodName', //
    title: '收款方式',
    width: '140',
  },
  {
    field: 'paperContractNo',
    title: '纸质合同号',
    width: '140',
  },
  {
    field: 'projectName', //
    title: '项目名称',
    width: '140',
  },
  {
    field: 'projectCode',
    title: '项目编号',
    width: '140',
  },
  {
    field: 'remarks',
    title: '备注',
    width: '140',
  },
];
